
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxChartsModule, ChartCommonModule } from '@swimlane/ngx-charts';
import { CustomCircleSeriesComponent } from '@nttp/area-chart/circle/np-circle-series.component';
import { CustomAreaChartComponent } from '@nttp/area-chart/np-area-chart.component';
import { CustomXAxisTicksComponent } from '@nttp/area-chart/x-axis/x-axis-ticks.component';
import { CustomXAxisComponent } from '@nttp/area-chart/x-axis/x-axis.component';
import { CustomLineSeriesComponent } from '@nttp/area-chart/line/line-series.component';
import { CustomYAxisTicksComponent } from '@nttp/area-chart/y-axis/y-axis-ticks.component';
import { CustomYAxisComponent } from '@nttp/area-chart/y-axis/y-axis.component';
import {CustomCircleSeriesWhiteComponent} from '@nttp/area-chart/circle/np-circle-series.component-white';

export const areaCharts = [
  CustomCircleSeriesComponent,
  CustomXAxisTicksComponent,
  CustomXAxisComponent,
  CustomAreaChartComponent,
  CustomLineSeriesComponent,
  CustomYAxisTicksComponent,
  CustomYAxisComponent,
  CustomCircleSeriesWhiteComponent
];

@NgModule({
  imports: [
    CommonModule,
    ChartCommonModule,
    NgxChartsModule,
  ],
  declarations: [areaCharts],
  exports: [areaCharts]
})
export class AreaChartsModule { }
